const initialPageState = {
  email: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
  location: "",
  username: "",
  instagramUsername: "",
  twitterUsername: "",
  goodFitInfo: "",
  serverError: "",
};

const influencerApplication = (state = initialPageState, action) => {
  switch (action.type) {
    case "INFLUENCER_APPLICATION_CACHE_SET":
      return {
        ...state,
        ...action.payload,
      };
    case "INFLUENCER_APPLICATION_CACHE_CLEAR":
      return {};
    case "SET_SERVER_ERROR":
      return {
        ...state,
        serverError: action.payload.serverError,
      };

    default:
      return {
        ...state
      };
  }
};

export default influencerApplication;
